<script lang="ts">
import type { Image, InstantWinResult } from '@/types'
import { InstantWinPrizeType, InstantWinType } from '@/utils/helper-objects'
import { capitalCase } from 'change-case'
import { type PropType, defineComponent } from 'vue'

/**
 * InstantWinResultCard
 */
export default defineComponent({
  props: {
    instantWinResult: {
      type: Object as PropType<InstantWinResult & { image: Image }>,
      required: true,
    },
  },
  setup() {
    return {
      InstantWinPrizeType,
      capitalCase,
    }
  },
  computed: {
    isInstantSpin(): boolean {
      return (
        this.instantWinResult.instant_win_type === InstantWinType.InstantSpin
      )
    },
  },
})
</script>

<template>
  <div
    class="inline-flex flex-grow flex-shrink-0 overflow-hidden h-[120px] items-center rounded-lg border border-[var(--color-on-surface-border,#B6C6CF)] bg-pure-white max-w-[280px]"
  >
    <div
      class="instant-win-result-card-image flex flex-col h-full min-w-[120px] w-[120px] items-center p-3 bg-primary/20 rounded-l-lg gap-2 self-stretch justify-end"
    >
      <img
        :src="instantWinResult.image.src"
        :alt="instantWinResult.image.alt"
        class="rounded-md object-cover aspect-square"
      />
    </div>

    <div
      class="flex flex-col gap-3 px-3 py-2 rounded-r-lg rounded-l-none flex-grow justify-between"
    >
      <div class="flex flex-col items-start gap-2 w-full max-w-[138px]">
        <div class="flex flex-col w-full">
          <p class="truncate font-bold leading-tight">
            {{ instantWinResult.customer }}
          </p>
          <p class="truncate font-bold leading-tight">
            {{ instantWinResult.prize?.replace(/(\£)/g, $t('currencySymbol')) }}
            <span
              v-if="
                instantWinResult.prize_type === InstantWinPrizeType.Cash ||
                instantWinResult.prize_type === InstantWinPrizeType.Credit
              "
              class="font-bold"
            >
              {{ capitalCase(instantWinResult.prize_type) }}
            </span>
          </p>
        </div>

        <p class="text-xs">
          Ticket: <strong>{{ instantWinResult.ticket }}</strong>
        </p>
      </div>
      <div class="flex">
        <AppButton
          class="button button-primary inline-flex items-center justify-center !px-2 !py-1 text-xs capitalize font-semibold !max-w-[100px] w-full"
          :route="{
            name: 'instant-win',
            params: { instantWinCode: instantWinResult.instant_win_code },
          }"
          title="View Draw"
        >
          View Draw
        </AppButton>
      </div>
    </div>
  </div>
</template>
